import clsx from "clsx";
import { PropsWithChildren, useRef } from "react";
import "swiper/css";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import Icon from "../Icon/Icon";
import styles from "./Slider.module.scss";

type SliderProps = PropsWithChildren<{
  items?: number | "auto";
  autoplay?: boolean;
  navigation?: boolean;
  centerInsufficientSlides?: boolean;
  singleMobileItem?: boolean;
  spaceBetween?: number;
  className?: string;
  classNameWrapper?: string;
  classNamePrevButton?: string;
  classNameNextButton?: string;
}>;

const Slider = ({
  items = 4,
  autoplay = false,
  navigation = false,
  centerInsufficientSlides = false,
  singleMobileItem = false,
  spaceBetween = 0,
  className,
  classNameWrapper,
  classNamePrevButton,
  classNameNextButton,
  children,
}: SliderProps) => {
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);

  return (
    <div className={styles.sliderWrapper}>
      {navigation && (
        <>
          <button
            type="button"
            ref={navigationPrevRef}
            className={clsx(styles.prev, styles.navButton, classNamePrevButton)}
          >
            <Icon icon="prev" className={styles.icon} />
          </button>
          <button
            type="button"
            ref={navigationNextRef}
            className={clsx(styles.next, styles.navButton, classNameNextButton)}
          >
            <Icon icon="next" className={styles.icon} />
          </button>
        </>
      )}
      <Swiper
        slidesPerView={items}
        autoplay={autoplay}
        navigation={{
          enabled: navigation,
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        spaceBetween={spaceBetween}
        modules={[Autoplay, Navigation]}
        wrapperClass={clsx(classNameWrapper)}
        className={clsx(styles.slider, className)}
        centerInsufficientSlides={centerInsufficientSlides}
        onBeforeInit={(swiper) => {
          if (typeof swiper.params.navigation !== "boolean") {
            if (swiper.params.navigation) {
              swiper.params.navigation.prevEl = navigationPrevRef.current;
              swiper.params.navigation.nextEl = navigationNextRef.current;
            }
          }
        }}
        breakpoints={{
          0: {
            slidesPerView: singleMobileItem ? 2 : items,
          },
          800: {
            slidesPerView: items,
          },
        }}
      >
        {children}
      </Swiper>
    </div>
  );
};

export default Slider;
